const getImageSchema = (name = "", contentUrl = "", description = "") => {
  const data: any = {
    "@context": "https://schema.org/",
    "@type": "ImageObject",
  };

  if (name) {
    data.name = name;
  }
  if (contentUrl) {
    data.contentUrl = contentUrl;
  }
  if (description) {
    data.description = description;
  }

  return data;
};

const getImageSchemaForInventory = (data: any = {}) => {
  const images = [...data?.images];
  data?.children_short?.forEach((child: any) => {
    if (child?.images?.length > 0) {
      images.push(...child.images);
    }
  });

  const schemaArray = images.map((img) => getImageSchema(img?.caption, img?.path, img?.type));

  return schemaArray;
};

export default getImageSchemaForInventory;
